import { Component, Input, Host } from '@angular/core';
import { SagCheckboxGroupComponent } from './sag-checkbox-group.component';

@Component({
    selector: 'sagcheckbox',
    template: `
    <div (click)="toggleCheck()"  [ngClass]="cls">
        <input type="checkbox"  class="form-check-input" [checked]="isChecked()" />
        <ng-content></ng-content>
    </div>`
})
export class SagCheckboxComponent {
    @Input() value: any;
    @Input() cls?: any;

    constructor(@Host() private checkboxGroup: SagCheckboxGroupComponent) {
    }
    toggleCheck() {
        this.checkboxGroup.addOrRemove(this.value);
    }
    isChecked() {
        return this.checkboxGroup.contains(this.value);
    }
}
